<script setup lang="ts">
import { ref, watch } from 'vue';
import { format, toZonedTime } from 'date-fns-tz';

import { TimeZoneItem, localTimeZomes } from '@/constants/localData';

export interface Props {
  modelValue?: string | null;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
});
const emit = defineEmits<{
  'update:modelValue': [value: (typeof props)['modelValue']];
}>();

const fieldValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newModelValue) => {
    fieldValue.value = newModelValue;
  },
);

watch(fieldValue, (newFieldValue) => {
  emit('update:modelValue', newFieldValue);
});

const formatTimeZone = (item: TimeZoneItem): string => {
  const now = new Date();
  const zonedDate = toZonedTime(now, item.timeZone);
  return `${item.zoneCode} / ${item.offset} – ${format(zonedDate, 'ccc, HH:mm:ss a')}`;
};
</script>

<template>
  <v-select
    v-model="fieldValue"
    label="Time zone"
    :items="localTimeZomes"
    item-title="city"
    item-value="city"
    menu-icon="mdi-chevron-down"
    variant="outlined"
    :class="['g-v-text-field']"
    data-testid="timeZoneSelect"
  >
    <template #item="{ item, props: selectProps }">
      <v-list-item v-bind="selectProps">
        <v-list-item-subtitle>
          {{ formatTimeZone(item.raw) }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
  </v-select>
</template>
